/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orderFeedbackSchema = z.object({
	score: z.int().nullable(),
	comment: z.string().nullable(),
});
